// ES6 Polyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'lazysizes';
import multirange from './modules/polyfill-multirange';
import search from './modules/search';
import backendFormCollections from './modules/backend-form-collections';
import listingFunctions from './modules/listing';
import headerSearchToggle from './modules/header-search';
import swiperInstances from './modules/swiper-instances';
import rellaxInstances from './modules/rellax-instances';
import overlayInstances from './modules/overlay-instances';
import wristcheckLightbox from './modules/wristcheckLightbox';
import tracking from './modules/tracking';
import priceSlider from './modules/priceslider';
import backendOverlaySelector from './modules/backend-overlay-selector';
import backendGraphs from './modules/backend-graphs';
import endlessListingScrolling from './modules/endlessListingScrolling';
import scrollspyNavigation from './modules/scrollspy-navigation';

$(() => {
    tracking.init();
    multirange.init();
    swiperInstances.init();
    rellaxInstances.init();
    overlayInstances.init();
    listingFunctions.init();
    headerSearchToggle.init();
    backendFormCollections.init('.js-form-collection');
    backendOverlaySelector.init();
    backendGraphs.init();
    search.init();
    wristcheckLightbox.init();
    priceSlider.init();
    endlessListingScrolling.init();
    scrollspyNavigation.init();
});
